import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useTheme } from "./ThemeContext";
import { FaDiscord, FaPatreon, FaInstagram } from "react-icons/fa";

export default function Contact() {
  const [status, setStatus] = useState("idle");
  const { darkMode, setDarkMode } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    const formData = new FormData(e.target);
    const payload = {};
    formData.forEach((value, key) => (payload[key] = value));

    try {
      const res = await fetch("https://zxldev.com/submit_contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setStatus("success");
        e.target.reset();
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <div className="min-h-screen bg-white text-black dark:bg-black dark:text-white transition-all duration-300">
      {/* NAVBAR */}
      <div className="flex justify-between items-center px-6 py-8 border-b border-gray-700">
        <h1 className="text-3xl font-bold text-red-500">ZXL Studio</h1>
        <div className="flex items-center space-x-6 text-sm text-gray-300">
          <nav className="space-x-6">
            <Link to="/" className="hover:text-white">Home</Link>
            <Link to="/services" className="hover:text-white">Services</Link>
            <a href="https://zxldev.com/blog" target="_blank" rel="noopener noreferrer" className="hover:text-white">Blog</a>
			<a href="https://zxldev.com/forums" target="_blank" rel="noopener noreferrer">Forums</a>
          </nav>
          <div className="flex space-x-3 text-xl">
            <a href="https://discord.com/channels/1077475224032911370/1077475224502681665" target="_blank" rel="noopener noreferrer"><FaDiscord className="hover:text-white" /></a>
            <a href="https://www.instagram.com/zxlstudio/?igsh=aGswYndpcm81OXFx" target="_blank" rel="noopener noreferrer"><FaInstagram className="hover:text-white" /></a>
			<a href="https://www.patreon.com/zxlstudio" target="_blank" rel="noopener noreferrer"><FaPatreon className="hover:text-white" /></a>
            <button onClick={() => setDarkMode(!darkMode)} title="Toggle theme">{darkMode ? "☀" : "🌙"}</button>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <main className="px-6 py-10 font-sans">
        <header className="text-center mb-10">
          <h1 className="text-4xl font-bold mb-2">Contact</h1>
          <p className="text-gray-400 text-lg">Get in touch for commissions, collaborations, or questions.</p>
        </header>

        <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-6">
          <input name="name" required type="text" placeholder="Your Name" className="w-full p-3 rounded bg-gray-800 border border-gray-600 text-white" />
          <input name="email" required type="email" placeholder="Your Email" className="w-full p-3 rounded bg-gray-800 border border-gray-600 text-white" />
          <input name="subject" type="text" placeholder="Subject" className="w-full p-3 rounded bg-gray-800 border border-gray-600 text-white" />
          <textarea name="message" required rows="5" placeholder="Your Message or Project Details" className="w-full p-3 rounded bg-gray-800 border border-gray-600 text-white" />

          <label className="block text-sm text-gray-400">What services are you interested in?</label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
            {["AI Character Art", "AI Video Generation", "Lore Writing", "RPGMaker Scripting", "Something Else"].map(service => (
              <label key={service} className="flex items-center gap-2">
                <input type="checkbox" name="services" value={service} className="accent-red-600" />
                {service}
              </label>
            ))}
          </div>

          <input type="text" name="honeypot" className="hidden" autoComplete="off" />
          <input name="timeline" type="text" placeholder="Deadline / Timeline (optional)" className="w-full p-3 rounded bg-gray-800 border border-gray-600 text-white" />
          <select name="budget" className="w-full p-3 rounded bg-gray-800 border border-gray-600 text-white">
            <option value="">Select Budget Range</option>
            <option value="<50">&lt;$50</option>
            <option value="50-150">$50–$150</option>
            <option value="150-500">$150–$500</option>
            <option value="500+">$500+</option>
            <option value="unknown">Still figuring it out</option>
          </select>

          <button type="submit" className="bg-red-600 px-6 py-3 rounded text-white hover:bg-red-500">
            {status === "sending" ? "Sending..." : "Submit"}
          </button>

          {status === "success" && <p className="text-green-400 mt-4">Thanks! I’ll get back to you soon.</p>}
          {status === "error" && <p className="text-red-400 mt-4">Something went wrong. Please try again later.</p>}
        </form>
      </main>
    </div>
  );
}
